var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-config-provider',{attrs:{"locale":_vm.zh_CN}},[_c('div',{class:_vm.SCREEN.mobile ? 'm-screen-mobile' : 'm-screen-pc',attrs:{"id":"webpatientApp"}},[(_vm.reload)?_c('router-view'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }